import React, {Component} from 'react';

import {
  Step,
  Stepper,
  StepLabel,
  StepContent,
} from 'material-ui/Stepper';

export default class AmeldungSchritte extends Component {
  render() {
    const {orientation, activeStep, children} = this.props;

    if (activeStep < 0)
      return (
        children
      );

    if (orientation === 'horizontal')
      return (
        <div key="HorizontalStepper">
          <Stepper activeStep={this.props.activeStep} orientation={orientation}>
            <Step>
              <StepLabel>Daten des Erziehungsberechtigten angeben</StepLabel>
            </Step>
            <Step>
              <StepLabel>Kinder anmelden</StepLabel>
            </Step>
            <Step>
              <StepLabel>Anmeldung abschlie&szlig;en</StepLabel>
            </Step>
            <Step>
              <StepLabel>Link in E-Mail aufrufen.</StepLabel>
            </Step>
          </Stepper>
          { children }
        </div>
      );

    return (
      <div key="VerticalStepper">
        <Stepper activeStep={this.props.activeStep} orientation={orientation}>
          <Step>
            <StepLabel>Daten des Erziehungsberechtigten angeben</StepLabel>
            <StepContent>
              {this.props.children}
            </StepContent>
          </Step>
          <Step>
            <StepLabel>Kinder anmelden</StepLabel>
            <StepContent>
              {this.props.children}
            </StepContent>
          </Step>
          <Step>
            <StepLabel>Anmeldung abschlie&szlig;en</StepLabel>
            <StepContent>
              {this.props.children}
            </StepContent>
          </Step>
          <Step>
            <StepLabel>Link in E-Mail aufrufen.</StepLabel>
            <StepContent>
              {children}
            </StepContent>
          </Step>
        </Stepper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/anmeldung-schritte/AnmeldungSchritte.jsx